import { BaseModel } from '@/core/standard/BaseModel';
import OfferService from '@/modules/offers/OfferService';
import { IOfferModel, IOffers, OfferProtocol } from '@/modules/offers/IOfferModel';

const offer = {
    name: '',
    qr: '',
    code: '',
    price: 0,
    start_date: '',
    end_date: '',
    discount_type: 'percent',
    description: '',
    limit_uses: 0,
    limit_uses_client: 0,
};

class OfferModel extends BaseModel<IOfferModel, OfferProtocol> {
    public modelName = 'Oferta';

    public request = 'JSON';

    constructor() {
        super(offer, OfferService);
    }

    public async validateByCode(code: string, client: number | null = null): Promise<any> {
        try {
            const response = await this.service.validateByCode({ code, client });
            if (response) {
                return response || null;
            }
        } catch (error) {
            return error;
        }
    }

    public async checkCodeUniqueness(params) {
        const response = await this.service.checkCodeUniqueness(params);

        if(response) {
            return response;
        }

        return;
    }
}

export default OfferModel as new () => IOffers;
